import { Component, Input, Provider, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HRGetPRCo_Result } from '../../../../type-definitions/admin/responses/admin';

const COMPANY_INPUT_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CompanyInputComponent),
  multi: true,
};

@Component({
  selector: 'app-company-input',
  templateUrl: './company-input.component.html',
  styleUrl: './company-input.component.scss',
  providers: [COMPANY_INPUT_VALUE_ACCESSOR],
})
export class CompanyInputComponent implements ControlValueAccessor {
  @Input() isDropdown: boolean;
  @Input() companies: HRGetPRCo_Result[];
  @Input() isDisabled = false;
  selectedCompany: number;

  private onChange!: Function;
  private onTouched!: Function;

  writeValue(company: number) {
    this.selectedCompany = company;
  }

  registerOnChange(fn: Function) {
    this.onChange = (company: number) => {
      fn(company);
    };
  }

  registerOnTouched(fn: Function) {
    this.onTouched = fn;
  }

  companyChanged(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.onChange(Number(value));
  }
}
